/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SubmitOnboardingSurveyRequestBody = {
  /**
   * Use case the survey answers resolved to.
   */
  useCase: string;
};

/** @internal */
export type SubmitOnboardingSurveyRequestBody$Outbound = {
  use_case: string;
};

/** @internal */
export const SubmitOnboardingSurveyRequestBody$outboundSchema: z.ZodMiniType<
  SubmitOnboardingSurveyRequestBody$Outbound,
  SubmitOnboardingSurveyRequestBody
> = z.pipe(
  z.object({
    useCase: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      useCase: "use_case",
    });
  }),
);

export function submitOnboardingSurveyRequestBodyToJSON(
  submitOnboardingSurveyRequestBody: SubmitOnboardingSurveyRequestBody,
): string {
  return JSON.stringify(
    SubmitOnboardingSurveyRequestBody$outboundSchema.parse(
      submitOnboardingSurveyRequestBody,
    ),
  );
}
